module.exports = __webpack_public_path__ + "img/leather-shoes.11b5ed53.webp";